import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NavService} from "../../../_services/_nav.service";
import {ConfirmationService} from "primeng/api";
import {Location} from "@angular/common";
import {ActivatedRoute, Params} from "@angular/router";
import {TasasVariablesService} from "../../../_services/tasas-variables.service";

@Component({
  selector: 'app-tasas-variables-editar',
  templateUrl: './tasas-variables-editar.component.html',
  styleUrls: ['./tasas-variables-editar.component.css']
})
export class TasasVariablesEditarComponent implements OnInit {

  @Input() verDetalle: boolean = false;
  carInformacionInicial: boolean = true;
  tabSeleccionado = "DATOSGEN";
  formulario: FormGroup;
  codExiste = false;
  registro: any;
  lisCompleta: any[] = [];
  submitted: boolean = false;
  guardando: boolean = false;


  constructor(private fb: FormBuilder,
              private navService: NavService,
              private conServicio: ConfirmationService,
              private location: Location,
              private route: ActivatedRoute,
              private tasasVariablesService: TasasVariablesService) {
  }

  ngOnInit() {
    this.tasasVariablesService.listadoPrincipal().subscribe(res => {
      this.lisCompleta = res;
    });
    this.route.params.subscribe( ( params: Params ) => {
      if ( params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined ) {
        this.tasasVariablesService.obtenerPorId( params[ 'id' ] ).subscribe( registro => {
          this.registro = registro;
          this.cargarFormulario();
          this.carInformacionInicial = false;
        } );
      } else {
        this.cargarFormulario();
        this.carInformacionInicial = false;
      }
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idTasaVariable: [this.registro ? this.registro.idTasaVariable : null],
      codigo: [{value: this.registro ? this.registro.codigo : null, disabled: (this.registro && this.registro.idTasaVariable)}, [Validators.required]],
      tasaVariable: [{value: this.registro ? this.registro.tasaVariable : null, disabled: this.verDetalle}, [Validators.required]],
      codigoShivam: [{value: this.registro ? this.registro.codigoShivam : null, disabled: this.verDetalle}, [Validators.required]],
      descripcion: [{value: this.registro ? this.registro.descripcion : null, disabled: this.verDetalle}, []],
      indicadorHabilitado: [{value: this.registro ? this.registro.indicadorHabilitado : true, disabled: this.verDetalle}, []]
    });
  }

  get f() {
    return this.formulario.controls
  }

  abrirAcordeon(evento: any) {
    switch (evento.index) {
      case 0: {
        this.tabSeleccionado = "DATOSGEN";
        break;
      }
      case 1: {
        this.tabSeleccionado = "TASAS";
        break;
      }
      default: {
        break;
      }
    }
  }

  validarCodigo() {
    this.codExiste = !!this.lisCompleta.find(x => x.codigo === this.f.codigo.value);
  }

  onSubmit() {
    this.submitted = true;
    if (this.formulario.valid && !this.codExiste) {
      this.guardando = true;
      const registro = this.formulario.value;
      if (this.registro && this.registro.idTasaVariable) {
        this.tasasVariablesService.actualizar(registro).subscribe(res => {
          this.registro = res;
          this.submitted = false;
          this.guardando = false;
          this.tabSeleccionado = 'TASAS';
          this.navService.setMesage(0, {
            severity: 'success', summary: this.navService.buscarMensaje('LBL_INFORMACION'),
            detail: this.navService.buscarMensaje('FABRICACREDITOPOLITICAS.MSG_NOTIFICACION')
          });
        }, error => {
          this.submitted = false;
          this.guardando = false;
          this.navService.setMesage(0, {
            severity: 'error', summary: this.navService.buscarMensaje('LBL_INFORMACION'),
            detail: this.navService.buscarMensaje('FABRICACREDITO.LBL_HAOCURRIDOERROR')
          });
        });
      } else {
        this.tasasVariablesService.crear(registro).subscribe(res => {
          this.registro = res;
          this.submitted = false;
          this.guardando = false;
          this.tabSeleccionado = 'TASAS';
          this.navService.setMesage(0, {
            severity: 'success', summary: this.navService.buscarMensaje('LBL_INFORMACION'),
            detail: this.navService.buscarMensaje('COMITEAPROBACION.MSG_ACTUALIZACION')
          });
        }, error => {
          this.submitted = false;
          this.guardando = false;
          this.navService.setMesage(0, {
            severity: 'error', summary: this.navService.buscarMensaje('LBL_INFORMACION'),
            detail: this.navService.buscarMensaje('FABRICACREDITO.LBL_HAOCURRIDOERROR')
          });
        });
      }
    }
  }

  regresar(dirty: boolean) {
    if (dirty) {
      this.conServicio.confirm({
        message: this.navService.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      });
    } else {
      this.location.back();
    }
  }

}
